import moment from 'moment';

export function Transaction(data) {
  // ReSharper disable MisuseOfOwnerFunctionThis
  this.date = moment
    .utc()
    .startOf('day')
    .toDate();
  this.amount = 0;
  this.name = '';
  this.iban = '';
  this.bic = '';
  this.description = '';
  this.payments = [];
  if (data) {
    angular.extend(this, data);
    if (typeof this.date === 'string') this.date = new moment(this.date).toDate();
  }

  this.openAmount = function() {
    if (!this.payments || !this.payments.length) return this.amount;
    return (
      this.amount -
      this.payments.reduce(function(sum, pay) {
        return sum + (pay.amount || 0);
      }, 0)
    );
  };
}
